import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const AdminPoints = lazy(() =>
  import(/* webpackChunkName: "AdminPoints" */ '../../components/rewards/AdminPoints')
);

export default function AsyncAdminPoints({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <AdminPoints {...props} />
    </Suspense>
  );
}
